module.exports = __webpack_public_path__ + "static/media/portfolio.45b48090.JPG";